import type { ReactNode } from 'react'
import { useI18n } from '../i18n'

interface AuthLayoutProps {
  title: string
  description?: string
  children: ReactNode
}

// The card never waits for the decorative photograph or an authentication read.
export function AuthLayout({ title, description, children }: AuthLayoutProps) {
  const { locale, setLocale, t } = useI18n()
  return (
    <main className="auth-layout">
      <section className="auth-card" aria-labelledby="auth-title">
        <header className="auth-header">
          <a href="https://www.togaphotos.com" className="auth-brand" aria-label={t('TOGAPhotos home')}>
            <img src="/brand/togaphotos-logo.webp" alt="TOGAPhotos" width="600" height="76" />
          </a>
          <h1 id="auth-title">{title}</h1>
          {description && <p>{description}</p>}
        </header>
        {children}
        <footer className="auth-footer">
          <label className="auth-language">
            <span>{t('Language')}</span>
            <select value={locale} onChange={event => setLocale(event.target.value === 'zh-CN' ? 'zh-CN' : 'en')}>
              <option value="en" lang="en">English</option>
              <option value="zh-CN" lang="zh-CN">简体中文</option>
            </select>
          </label>
        </footer>
      </section>
    </main>
  )
}

export function AuthLoading({ message }: { message?: string }) {
  const { t } = useI18n()
  return (
    <div className="auth-loading" role="status" aria-live="polite">
      <span className="auth-spinner" aria-hidden="true" />
      <span>{t(message || 'Preparing your sign-in form…')}</span>
    </div>
  )
}
